import {Component, OnInit, ViewChild} from '@angular/core';
import {AlarmService} from '../../../shared/services/alarm/alarm.service';
import {ActivatedRoute} from '@angular/router';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {AbstractMatTable} from '../../../shared/classes/mat-table/abstract-mat-table';
import {RouteService} from '../../../shared/services/route/route.service';
import {IconService} from '../../../shared/services/icon/icon.service';

@Component({
  selector: 'app-project-last-alarms',
  templateUrl: './project-last-alarms.component.html',
  styleUrls: ['./project-last-alarms.component.css']
})

export class ProjectLastAlarmsComponent extends AbstractMatTable implements OnInit {

  public projectId: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public iconService: IconService,
              private alarmService: AlarmService,
              private activatedRoute: ActivatedRoute,
              private routeService: RouteService) {
    super();
  }

  ngOnInit(): void {
    this.projectId = parseInt(this.activatedRoute.snapshot.paramMap.get('idProject'));
    this.setMatTable(this.alarmService.getProjectsLastAlarms(this.projectId),
      ['projectName', 'time', 'type', 'threshold', 'locationName', 'deviceType', 'action']);
  }

  navigateToChart(locationId: string, dateStart: string) {
    this.routeService.navigateToChartDynData(this.projectId, locationId, dateStart);
  }


}
